export default __webpack_public_path__ + "static/media/CoverIMG.0d93453a.jpg";